import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { DeleteSchedule, Environments } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../../ProgressSpinner/Index";
import { setNotification } from "../../../../utilities/HttpRequest/Script";
import { NotificationType } from "../../../Notification/redux/Types";
import { CreateScheduleSlice } from "../CreateSchedule/redux";
import { IRootState } from "../../../../reducer/CombineReducer";
import { SchedulingModes } from "../CreateSchedule/redux/Types";
import { handleException } from "../../../../ErrorMessages/helper";
import { useUser } from "../../../../AuthContext";
import { ScheduleRemoveView } from "./ScheduleRemove.view";

export const ScheduleRemove = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const [
    extractState,
    scheduling
  ] = useSelector((state: IRootState) => [
    state.extractState,
    state.scheduling
  ], shallowEqual);
  const scheduleGuid = scheduling.schedulingDetails.scheduleGuid;
  const scheduleName = scheduling.schedulingDetails.scheduleName;
  const isDeleteEnabled = scheduling.mode !== SchedulingModes.CREATE;
  const selectedExtractGuid = extractState.selectedExtract?.extractGuid;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * API call for deleting the schedule
   */

  const deleteRequest = async (): Promise<void> => {
    setShowAlert(false);
    try {
      dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.DeleteSchedule")));
      const response = await DeleteSchedule(
        selectedExtractGuid || "",
        String(scheduleGuid),
        env,
        user?.token
      );

      if (response && response["data"] && response["data"]["payload"]["message"] === "Deleted Successfully") {
        dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
        setNotification(
          dispatch,
          "delete-schedule",
          translate("Notification.ScheduleDelete"),
          NotificationType.Confirmation
        );
        dispatch(CreateScheduleSlice.actions.setScheduleListPage(false));
      }
    } catch (ex) {
      handleException(ex, dispatch, "DeleteExtractScheduleErrMsg");
    }
  };

  return (
    <div>
      <ScheduleRemoveView
        onDelete={deleteRequest}
        showAlert={showAlert}
        scheduleName={scheduleName}
        isDeleteEnabled={isDeleteEnabled}
      />
    </div>

  );
};
